/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bill amount`)
};

const es_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe de la cuenta`)
};

const de_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsbetrag`)
};

const nl_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekeningbedrag`)
};

const fr_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant de l'addition`)
};

const it_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo del conto`)
};

const pt_br2_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da conta`)
};

const pt_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da conta`)
};

const ja_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会計額`)
};

const zh_pct_field_bill = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_field_bill = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_field_bill(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_field_bill", locale)
	if (locale === "en") return en_pct_field_bill(inputs)
	if (locale === "es") return es_pct_field_bill(inputs)
	if (locale === "de") return de_pct_field_bill(inputs)
	if (locale === "nl") return nl_pct_field_bill(inputs)
	if (locale === "fr") return fr_pct_field_bill(inputs)
	if (locale === "it") return it_pct_field_bill(inputs)
	if (locale === "pt-BR") return pt_br2_pct_field_bill(inputs)
	if (locale === "pt") return pt_pct_field_bill(inputs)
	if (locale === "ja") return ja_pct_field_bill(inputs)
	return zh_pct_field_bill(inputs)
};